// Quiz icons: space, nature, body, matter, energy.
// Each svg is the inside of a 120x120 viewBox. The outline style (ink colour,
// 4px round stroke) is set once on the wrapper, so shapes only carry fills.
// stroke="none" marks flat accents that should have no outline.
export const SCIENCE_ICONS = [
  { id: "sun", en: "Sun", da: "Sol", svg: `
<path d="M60 10v13M60 97v13M10 60h13M97 60h13M25 25l9 9M86 86l9 9M95 25l-9 9M34 86l-9 9" fill="none" stroke="#3B3355" stroke-width="5"/>
<circle cx="60" cy="60" r="26" fill="#FFC857"/>
<circle cx="51" cy="51" r="6" fill="#fff" opacity=".7" stroke="none"/>
<path d="M50 70 q10 7 20 0" fill="none" stroke="#E0A955" stroke-width="3"/>` },

  { id: "moon", en: "Moon", da: "Måne", svg: `
<path d="M70 14 a46 46 0 1 0 36 70 a38 38 0 1 1 -36 -70Z" fill="#FFE37A"/>
<circle cx="44" cy="54" r="6" fill="#F4C976"/><circle cx="58" cy="82" r="8" fill="#F4C976"/><circle cx="36" cy="80" r="4" fill="#F4C976"/>
<path d="M92 26 l2.5 5 5.5 1 -4 4 1 5.5 -5 -2.5 -5 2.5 1 -5.5 -4 -4 5.5 -1z" fill="#fff" stroke-width="2.5"/>` },

  { id: "earth", en: "Earth", da: "Jorden", svg: `
<circle cx="60" cy="60" r="44" fill="#7FC8F8"/>
<path d="M30 40 q10 -14 26 -12 q8 6 2 14 q-10 2 -8 12 q-4 10 -14 6 q-10 -8 -6 -20Z" fill="#7BD389"/>
<path d="M66 58 q14 -8 26 2 q4 14 -8 22 q-10 10 -16 2 q2 -10 -6 -14 q-2 -8 4 -12Z" fill="#7BD389"/>
<path d="M70 22 q10 0 14 8 q-8 4 -14 -2Z" fill="#7BD389"/>
<path d="M28 78 q8 14 22 20" fill="none" stroke="#fff" stroke-width="4" opacity=".7"/>` },

  { id: "planet", en: "Planet", da: "Planet", svg: `
<g transform="rotate(-18 60 60)"><path d="M10 60 a50 15 0 0 1 100 0" fill="none" stroke="#3B3355" stroke-width="12"/><path d="M10 60 a50 15 0 0 1 100 0" fill="none" stroke="#7FC8F8" stroke-width="5"/></g>
<circle cx="60" cy="60" r="30" fill="#FFC857"/>
<path d="M33 54 q27 8 54 -4" fill="none" stroke="#E0A955" stroke-width="4"/><path d="M32 68 q28 8 56 -2" fill="none" stroke="#E0A955" stroke-width="4"/>
<circle cx="49" cy="46" r="5" fill="#fff" opacity=".8" stroke="none"/>
<g transform="rotate(-18 60 60)"><path d="M10 60 a50 15 0 0 0 100 0" fill="none" stroke="#3B3355" stroke-width="12"/><path d="M10 60 a50 15 0 0 0 100 0" fill="none" stroke="#7FC8F8" stroke-width="5"/></g>
<path d="M100 14 l3 6 6 1 -5 4 1 6 -5 -3 -5 3 1 -6 -5 -4 6 -1z" fill="#FFE37A" stroke-width="2.5"/>` },

  { id: "mars", en: "Red planet", da: "Rød planet", svg: `
<circle cx="60" cy="60" r="40" fill="#E07A5F"/>
<path d="M40 24 q20 -8 40 0 q-20 8 -40 0Z" fill="#fff" stroke-width="3"/>
<circle cx="44" cy="62" r="8" fill="#C8604A" stroke-width="3"/><circle cx="74" cy="76" r="6" fill="#C8604A" stroke-width="3"/><circle cx="76" cy="48" r="4" fill="#C8604A" stroke-width="3"/>
<path d="M30 76 q8 16 24 22" fill="none" stroke="#fff" stroke-width="4" opacity=".6"/>` },

  { id: "rocket", en: "Rocket", da: "Raket", svg: `
<path d="M50 88 q10 26 10 26 q0 0 10 -26Z" fill="#FF7A45"/><path d="M55 88 q5 14 5 14 q0 0 5 -14Z" fill="#FFC857" stroke="none"/>
<path d="M42 62 l-16 18 v12 l18 -8Z" fill="#E8556D"/><path d="M78 62 l16 18 v12 l-18 -8Z" fill="#E8556D"/>
<path d="M60 10 q24 22 18 78 h-36 q-6 -56 18 -78Z" fill="#fff"/>
<path d="M48 22 q12 -10 24 0" fill="#E8556D" stroke-width="3"/>
<circle cx="60" cy="48" r="10" fill="#7FC8F8"/><circle cx="57" cy="45" r="3" fill="#fff" stroke="none"/>
<path d="M60 70 v14" fill="none"/>` },

  { id: "comet", en: "Comet", da: "Komet", svg: `
<path d="M78 42 L18 94 M70 34 L22 72 M86 50 L44 98" fill="none" stroke="#7FC8F8" stroke-width="7"/>
<path d="M78 42 L18 94 M70 34 L22 72 M86 50 L44 98" fill="none" stroke="#3B3355" stroke-width="3" stroke-dasharray="2 12"/>
<path d="M84 18 l8 16 18 3 -13 12 3 18 -16 -8 -16 8 3 -18 -13 -12 18 -3z" fill="#FFC857"/>
<circle cx="80" cy="34" r="3" fill="#fff" stroke="none"/>` },

  { id: "telescope", en: "Telescope", da: "Kikkert", svg: `
<path d="M56 70 l-20 38 M64 70 l20 38 M60 70 v38" fill="none"/>
<g transform="rotate(-28 60 56)"><rect x="22" y="44" width="70" height="22" rx="6" fill="#7FC8F8"/><rect x="90" y="40" width="12" height="30" rx="4" fill="#4A90D9"/><rect x="12" y="48" width="12" height="14" rx="3" fill="#B5B9D4"/><path d="M40 44 v22 M70 44 v22" fill="none" stroke-width="3"/></g>
<circle cx="60" cy="70" r="6" fill="#FFC857"/>
<path d="M104 14 l2 4 4 1 -3 3 1 4 -4 -2 -4 2 1 -4 -3 -3 4 -1z" fill="#FFE37A" stroke-width="2"/>` },

  { id: "atom", en: "Atom", da: "Atom", svg: `
<g fill="none"><ellipse cx="60" cy="60" rx="48" ry="17" stroke="#3B3355" stroke-width="9"/><ellipse cx="60" cy="60" rx="48" ry="17" stroke="#7FC8F8" stroke-width="4"/>
<g transform="rotate(60 60 60)"><ellipse cx="60" cy="60" rx="48" ry="17" stroke="#3B3355" stroke-width="9"/><ellipse cx="60" cy="60" rx="48" ry="17" stroke="#A78BFA" stroke-width="4"/></g>
<g transform="rotate(120 60 60)"><ellipse cx="60" cy="60" rx="48" ry="17" stroke="#3B3355" stroke-width="9"/><ellipse cx="60" cy="60" rx="48" ry="17" stroke="#7BD389" stroke-width="4"/></g></g>
<circle cx="60" cy="60" r="11" fill="#E8556D"/><circle cx="57" cy="57" r="3" fill="#fff" stroke="none"/>
<circle cx="108" cy="60" r="5" fill="#FFC857" stroke-width="3"/><circle cx="36" cy="19" r="5" fill="#FFC857" stroke-width="3"/>` },

  { id: "dna", en: "DNA", da: "DNA", svg: `
<path d="M47 24 h26 M51 48 h18 M51 72 h18 M47 96 h26" fill="none" stroke-width="5"/>
<g fill="none"><path d="M42 10 C42 36 78 36 78 60 C78 84 42 84 42 110" stroke="#3B3355" stroke-width="12"/><path d="M42 10 C42 36 78 36 78 60 C78 84 42 84 42 110" stroke="#7FC8F8" stroke-width="5"/>
<path d="M78 10 C78 36 42 36 42 60 C42 84 78 84 78 110" stroke="#3B3355" stroke-width="12"/><path d="M78 10 C78 36 42 36 42 60 C42 84 78 84 78 110" stroke="#FF6B81" stroke-width="5"/></g>` },

  { id: "cell", en: "Cell", da: "Celle", svg: `
<path d="M60 14 C92 12 110 38 106 64 C102 94 74 108 48 102 C20 96 10 70 16 46 C22 26 38 15 60 14Z" fill="#9BE3A6"/>
<circle cx="64" cy="58" r="18" fill="#A78BFA"/><circle cx="68" cy="54" r="6" fill="#7C5BD6" stroke="none"/>
<ellipse cx="36" cy="72" rx="9" ry="5" fill="#7BD389" transform="rotate(-30 36 72)"/><ellipse cx="80" cy="88" rx="8" ry="5" fill="#7BD389" transform="rotate(20 80 88)"/>
<circle cx="38" cy="40" r="3" fill="#5BB46C" stroke="none"/><circle cx="90" cy="38" r="3" fill="#5BB46C" stroke="none"/><circle cx="56" cy="88" r="3" fill="#5BB46C" stroke="none"/>` },

  { id: "microscope", en: "Microscope", da: "Mikroskop", svg: `
<path d="M24 104 h72" fill="none" stroke-width="6"/>
<path d="M36 104 v-8 h48 v8" fill="#B5B9D4"/>
<path d="M78 96 q14 -26 -6 -50" fill="none" stroke-width="10"/><path d="M78 96 q14 -26 -6 -50" fill="none" stroke="#C9CCE0" stroke-width="4"/>
<path d="M40 76 h34" fill="none" stroke-width="5"/>
<g transform="rotate(-30 56 44)"><rect x="46" y="14" width="20" height="50" rx="5" fill="#fff"/><rect x="44" y="8" width="24" height="10" rx="3" fill="#4A90D9"/><rect x="50" y="62" width="12" height="10" fill="#B5B9D4"/></g>
<circle cx="72" cy="46" r="7" fill="#FFC857"/>` },

  { id: "flask", en: "Experiment", da: "Forsøg", svg: `
<path d="M50 14 v30 l-26 50 q-4 12 10 12 h52 q14 0 10 -12 l-26 -50 v-30Z" fill="#fff"/>
<path d="M36 72 h48 l12 22 q3 8 -8 8 h-56 q-11 0 -8 -8Z" fill="#7BD389" stroke="none"/>
<path d="M50 14 v30 l-26 50 q-4 12 10 12 h52 q14 0 10 -12 l-26 -50 v-30" fill="none"/>
<path d="M44 12 h32" fill="none" stroke-width="6"/>
<circle cx="54" cy="86" r="4" fill="#fff" stroke-width="2.5"/><circle cx="68" cy="92" r="3" fill="#fff" stroke-width="2.5"/><circle cx="62" cy="62" r="3.5" fill="#fff" stroke-width="2.5"/><circle cx="58" cy="50" r="2.5" fill="#fff" stroke-width="2"/>` },

  { id: "magnet", en: "Magnet", da: "Magnet", svg: `
<path d="M24 22 h22 v42 a14 14 0 0 0 28 0 v-42 h22 v42 a36 36 0 0 1 -72 0Z" fill="#E8556D"/>
<path d="M24 22 h22 v14 h-22Z M74 22 h22 v14 h-22Z" fill="#E5E1EE"/>
<path d="M14 18 l-6 -6 M10 30 h-8 M106 18 l6 -6 M110 30 h8" fill="none" stroke="#FFC857"/>
<path d="M36 70 q6 14 18 16" fill="none" stroke="#fff" stroke-width="4" opacity=".7"/>` },

  { id: "lightbulb", en: "Light bulb", da: "Elpære", svg: `
<path d="M60 14 a30 30 0 0 0 -18 54 v12 h36 v-12 a30 30 0 0 0 -18 -54Z" fill="#FFE37A"/>
<path d="M52 80 v-18 l8 -8 8 8 v18" fill="none" stroke="#E0A955" stroke-width="3"/>
<rect x="44" y="80" width="32" height="8" rx="2" fill="#B5B9D4"/><rect x="46" y="88" width="28" height="8" rx="2" fill="#C9CCE0"/><path d="M52 96 h16 l-4 8 h-8Z" fill="#3B3355"/>
<path d="M46 30 q-8 8 -6 18" fill="none" stroke="#fff" stroke-width="4"/>
<path d="M18 40 l-8 -4 M16 60 h-9 M102 40 l8 -4 M104 60 h9 M30 16 l-5 -6 M90 16 l5 -6" fill="none" stroke="#FFC857" stroke-width="5"/>` },

  { id: "battery", en: "Battery", da: "Batteri", svg: `
<rect x="18" y="36" width="78" height="48" rx="10" fill="#fff"/><rect x="96" y="50" width="8" height="20" rx="3" fill="#B5B9D4"/>
<rect x="26" y="44" width="44" height="32" rx="5" fill="#7BD389" stroke="none"/>
<path d="M62 40 l-14 22 h12 l-6 20 l18 -26 h-12 l8 -16Z" fill="#FFC857" stroke-width="3"/>` },

  { id: "lightning", en: "Electricity", da: "Elektricitet", svg: `
<path d="M66 8 L28 66 h26 l-8 46 l44 -64 h-28 l14 -40Z" fill="#FFC857"/>
<path d="M60 22 l-18 32" fill="none" stroke="#fff" stroke-width="4" opacity=".8"/>
<path d="M98 22 l2 4 4 1 -3 3 1 4 -4 -2 -4 2 1 -4 -3 -3 4 -1z" fill="#FFE37A" stroke-width="2"/>` },

  { id: "drop", en: "Water", da: "Vand", svg: `
<path d="M60 10 C60 10 24 54 24 76 a36 36 0 0 0 72 0 C96 54 60 10 60 10Z" fill="#7FC8F8"/>
<path d="M40 74 q0 14 12 20" fill="none" stroke="#fff" stroke-width="5"/>
<circle cx="46" cy="62" r="3" fill="#fff" stroke="none"/>` },

  { id: "rain", en: "Rain", da: "Regn", svg: `
<path d="M30 66 a16 16 0 0 1 4 -31 a24 24 0 0 1 45 -6 a18 18 0 0 1 13 37Z" fill="#E5E1EE"/>
<path d="M40 44 q4 -8 12 -8" fill="none" stroke="#fff" stroke-width="4"/>
<path d="M38 80 q-5 8 0 10 q5 -2 0 -10Z M60 86 q-5 8 0 10 q5 -2 0 -10Z M82 80 q-5 8 0 10 q5 -2 0 -10Z M48 100 q-4 6 0 8 q4 -2 0 -8Z M72 100 q-4 6 0 8 q4 -2 0 -8Z" fill="#7FC8F8" stroke-width="3"/>` },

  { id: "watercycle", en: "Water cycle", da: "Vandets kredsløb", svg: `
<circle cx="24" cy="26" r="12" fill="#FFC857"/>
<path d="M52 44 a12 12 0 0 1 3 -23 a18 18 0 0 1 33 -4 a13 13 0 0 1 10 27Z" fill="#E5E1EE"/>
<path d="M10 96 q12 -8 25 0 t25 0 t25 0 t25 0 V112 H10Z" fill="#7FC8F8"/>
<path d="M30 84 v-30 M24 62 l6 -8 6 8" fill="none" stroke="#E0A955" stroke-width="4"/>
<path d="M78 52 l-4 8 M90 52 l-4 8 M66 52 l-4 8" fill="none" stroke="#4A90D9" stroke-width="4"/>
<path d="M44 84 v-22 M38 70 l6 -8 6 8" fill="none" stroke="#E0A955" stroke-width="4"/>` },

  { id: "thermometer", en: "Temperature", da: "Temperatur", svg: `
<path d="M50 74 V22 a10 10 0 0 1 20 0 V74 a18 18 0 1 1 -20 0Z" fill="#fff"/>
<circle cx="60" cy="88" r="11" fill="#E8556D"/><rect x="56" y="40" width="8" height="46" rx="4" fill="#E8556D" stroke="none"/>
<path d="M72 30 h10 M72 44 h8 M72 58 h10" fill="none" stroke-width="3"/>
<circle cx="56" cy="85" r="3" fill="#fff" stroke="none"/>` },

  { id: "icecube", en: "Ice", da: "Is", svg: `
<path d="M60 16 l38 18 v44 l-38 20 l-38 -20 v-44Z" fill="#DDF1FF"/>
<path d="M22 34 l38 18 l38 -18 M60 52 v46" fill="none"/>
<path d="M60 52 l38 -18 v44 l-38 20Z" fill="#B7E0FB" stroke="none"/>
<path d="M60 16 l38 18 v44 l-38 20 l-38 -20 v-44Z M22 34 l38 18 l38 -18 M60 52 v46" fill="none"/>
<path d="M32 46 v18" fill="none" stroke="#fff" stroke-width="5"/>
<path d="M104 18 l2 4 4 1 -3 3 1 4 -4 -2 -4 2 1 -4 -3 -3 4 -1z" fill="#fff" stroke-width="2"/>` },

  { id: "snowflake", en: "Snow", da: "Sne", svg: `
<g fill="none" stroke="#3B3355" stroke-width="10"><path d="M60 12 v96 M18 36 l84 48 M18 84 l84 -48"/></g>
<g fill="none" stroke="#B7E0FB" stroke-width="4"><path d="M60 12 v96 M18 36 l84 48 M18 84 l84 -48"/></g>
<g fill="none" stroke-width="4"><path d="M50 18 l10 10 10 -10 M50 102 l10 -10 10 10 M22 48 l14 -4 -4 -14 M98 72 l-14 4 4 14 M22 72 l14 4 -4 14 M98 48 l-14 -4 4 -14"/></g>
<circle cx="60" cy="60" r="8" fill="#fff"/>` },

  { id: "wind", en: "Wind", da: "Vind", svg: `
<g fill="none" stroke="#3B3355" stroke-width="11"><path d="M12 46 h58 a12 12 0 1 0 -12 -12"/><path d="M12 66 h78 a12 12 0 1 1 -12 12"/><path d="M22 86 h28"/></g>
<g fill="none" stroke="#B7E0FB" stroke-width="5"><path d="M12 46 h58 a12 12 0 1 0 -12 -12"/><path d="M12 66 h78 a12 12 0 1 1 -12 12"/><path d="M22 86 h28"/></g>
<path d="M96 22 q8 -2 10 6 q-8 4 -10 -6Z" fill="#7BD389" stroke-width="3"/>` },

  { id: "fire", en: "Fire", da: "Ild", svg: `
<path d="M60 8 C66 30 92 40 90 74 C88 98 72 110 60 110 C44 110 28 98 30 74 C31 58 40 50 44 38 C50 48 52 54 56 56 C58 40 54 24 60 8Z" fill="#FF7A45"/>
<path d="M60 56 C64 70 78 76 76 92 C74 104 66 106 60 106 C52 106 44 100 44 90 C44 80 52 76 54 68 C56 74 58 76 60 76 Z" fill="#FFC857" stroke-width="3"/>` },

  { id: "boiling", en: "Boiling", da: "Kogning", svg: `
<path d="M44 26 q-6 -8 0 -16 M60 30 q-6 -9 0 -18 M76 26 q-6 -8 0 -16" fill="none" stroke="#C9CCE0" stroke-width="5"/>
<path d="M22 44 h76 v40 a12 12 0 0 1 -12 12 h-52 a12 12 0 0 1 -12 -12Z" fill="#E8556D"/>
<path d="M14 52 h8 M98 52 h8" fill="none" stroke-width="6"/>
<path d="M18 38 h84 v8 h-84Z" fill="#B5B9D4"/>
<circle cx="44" cy="34" r="5" fill="#B7E0FB" stroke-width="3"/><circle cx="64" cy="30" r="4" fill="#B7E0FB" stroke-width="3"/><circle cx="80" cy="34" r="3" fill="#B7E0FB" stroke-width="3"/>
<path d="M32 56 v20" fill="none" stroke="#fff" stroke-width="5" opacity=".7"/>
<path d="M44 106 q4 -6 8 0 q4 -6 8 0 q4 -6 8 0 q4 -6 8 0" fill="none" stroke="#FF7A45" stroke-width="4"/>` },

  { id: "leaf", en: "Leaf", da: "Blad", svg: `
<path d="M22 98 C16 50 50 16 104 16 C104 70 70 104 22 98Z" fill="#7BD389"/>
<path d="M22 98 L84 36 M44 76 h20 M56 64 h18 M44 76 v-18 M58 62 v-16" fill="none" stroke="#5BB46C" stroke-width="4"/>
<path d="M14 106 l10 -10" fill="none" stroke-width="5"/>` },

  { id: "plant", en: "Plant", da: "Plante", svg: `
<path d="M34 78 h52 l-6 26 h-40Z" fill="#E07A5F"/><rect x="30" y="72" width="60" height="10" rx="3" fill="#E89A82"/>
<path d="M60 72 v-34" fill="none" stroke="#5BB46C" stroke-width="6"/><path d="M60 72 v-34" fill="none"/>
<path d="M60 46 q-30 2 -32 -22 q26 -2 32 22Z" fill="#7BD389"/>
<path d="M60 38 q24 -2 30 -24 q-26 -4 -30 24Z" fill="#9BE3A6"/>
<path d="M98 50 l2 4 4 1 -3 3 1 4 -4 -2 -4 2 1 -4 -3 -3 4 -1z" fill="#FFE37A" stroke-width="2"/>` },

  { id: "roots", en: "Roots", da: "Rødder", svg: `
<path d="M8 52 h104 v56 h-104Z" fill="#B07A57"/>
<circle cx="24" cy="74" r="3" fill="#8E5E40" stroke="none"/><circle cx="96" cy="92" r="3" fill="#8E5E40" stroke="none"/><circle cx="90" cy="66" r="2.5" fill="#8E5E40" stroke="none"/>
<path d="M60 52 v18 q0 14 -14 22 q-8 4 -10 12 M60 70 q2 14 16 18 q8 4 10 12 M60 64 q-10 2 -18 -4 M60 84 v18" fill="none" stroke="#F4E1C1" stroke-width="5"/>
<path d="M60 52 v-24" fill="none" stroke="#5BB46C" stroke-width="5"/>
<path d="M60 34 q-24 2 -26 -18 q22 -2 26 18Z" fill="#7BD389"/><path d="M60 30 q20 -2 24 -20 q-22 -2 -24 20Z" fill="#9BE3A6"/>` },

  { id: "tree", en: "Tree", da: "Træ", svg: `
<path d="M52 108 v-34 h16 v34Z" fill="#B07A57"/>
<path d="M60 10 c18 0 28 12 26 24 c14 4 18 24 6 34 c-6 10 -22 12 -32 8 c-10 4 -26 2 -32 -8 c-12 -10 -8 -30 6 -34 c-2 -12 8 -24 26 -24Z" fill="#7BD389"/>
<path d="M40 30 q6 -8 14 -8" fill="none" stroke="#fff" stroke-width="4" opacity=".7"/>
<circle cx="44" cy="54" r="5" fill="#E8556D" stroke-width="3"/><circle cx="76" cy="44" r="5" fill="#E8556D" stroke-width="3"/><circle cx="70" cy="66" r="5" fill="#E8556D" stroke-width="3"/>
<path d="M30 108 h60" fill="none"/>` },

  { id: "flower", en: "Flower", da: "Blomst", svg: `
<path d="M60 64 v46" fill="none" stroke="#5BB46C" stroke-width="6"/><path d="M60 64 v46" fill="none"/>
<path d="M60 96 q-24 0 -26 -18 q22 -2 26 18Z" fill="#7BD389"/>
<circle cx="60" cy="22" r="13" fill="#FF9BB0"/><circle cx="82" cy="38" r="13" fill="#FF9BB0"/><circle cx="74" cy="62" r="13" fill="#FF9BB0"/><circle cx="46" cy="62" r="13" fill="#FF9BB0"/><circle cx="38" cy="38" r="13" fill="#FF9BB0"/>
<circle cx="60" cy="44" r="12" fill="#FFC857"/><circle cx="56" cy="40" r="3" fill="#fff" stroke="none"/>` },

  { id: "cactus", en: "Desert", da: "Ørken", svg: `
<circle cx="94" cy="24" r="12" fill="#FFC857"/>
<path d="M4 108 q30 -16 60 -6 q30 -10 52 2 v8 h-112Z" fill="#F4C976"/>
<path d="M50 104 v-74 a10 10 0 0 1 20 0 v74Z" fill="#7BD389"/>
<path d="M50 68 h-12 a8 8 0 0 1 -8 -8 v-14 a5 5 0 0 1 10 0 v12 h10" fill="#7BD389"/>
<path d="M70 58 h12 a8 8 0 0 0 8 -8 v-10 a5 5 0 0 0 -10 0 v8 h-10" fill="#7BD389"/>
<path d="M56 40 v50 M64 44 v40" fill="none" stroke="#5BB46C" stroke-width="3"/>
<circle cx="60" cy="18" r="5" fill="#FF6B81" stroke-width="3"/>` },

  { id: "mushroom", en: "Mushroom", da: "Svamp", svg: `
<path d="M46 62 q-4 30 -2 42 h32 q2 -12 -2 -42Z" fill="#FFF3DC"/>
<path d="M14 64 C14 34 36 16 60 16 C84 16 106 34 106 64 Z" fill="#E8556D"/>
<circle cx="40" cy="42" r="7" fill="#fff" stroke="none"/><circle cx="66" cy="30" r="6" fill="#fff" stroke="none"/><circle cx="86" cy="50" r="6" fill="#fff" stroke="none"/><circle cx="58" cy="52" r="4" fill="#fff" stroke="none"/>
<path d="M30 108 h60" fill="none" stroke="#5BB46C" stroke-width="5"/>` },

  { id: "butterfly", en: "Butterfly", da: "Sommerfugl", svg: `
<path d="M58 54 C40 18 10 20 14 44 C16 58 34 62 56 60Z" fill="#A78BFA"/>
<path d="M62 54 C80 18 110 20 106 44 C104 58 86 62 64 60Z" fill="#A78BFA"/>
<path d="M56 62 C36 66 24 82 34 94 C44 102 54 86 58 70Z" fill="#FF9BB0"/>
<path d="M64 62 C84 66 96 82 86 94 C76 102 66 86 62 70Z" fill="#FF9BB0"/>
<circle cx="32" cy="42" r="6" fill="#FFE37A" stroke-width="3"/><circle cx="88" cy="42" r="6" fill="#FFE37A" stroke-width="3"/>
<rect x="55" y="40" width="10" height="56" rx="5" fill="#3B3355"/>
<path d="M58 40 q-6 -16 -14 -20 M62 40 q6 -16 14 -20" fill="none" stroke-width="3"/>` },

  { id: "bee", en: "Bee", da: "Bi", svg: `
<ellipse cx="48" cy="40" rx="18" ry="24" fill="#DDF1FF" transform="rotate(-20 48 40)"/><ellipse cx="74" cy="38" rx="16" ry="22" fill="#DDF1FF" transform="rotate(20 74 38)"/>
<ellipse cx="60" cy="72" rx="36" ry="26" fill="#FFC857"/>
<path d="M50 48 q-6 24 0 48 M70 48 q6 24 0 48" fill="none" stroke="#3B3355" stroke-width="9"/>
<path d="M96 72 l12 0" fill="none" stroke-width="5"/>
<circle cx="34" cy="66" r="4" fill="#3B3355" stroke="none"/>
<path d="M30 50 q-6 -12 -14 -14 M38 48 q-2 -14 -8 -18" fill="none" stroke-width="3"/>` },

  { id: "ladybug", en: "Insect", da: "Insekt", svg: `
<path d="M36 40 q-14 -16 -24 -14 M84 40 q14 -16 24 -14 M24 64 h-14 M96 64 h14 M28 88 l-12 10 M92 88 l12 10" fill="none" stroke-width="5"/>
<circle cx="60" cy="36" r="16" fill="#3B3355"/>
<circle cx="60" cy="68" r="38" fill="#E8556D"/>
<path d="M60 30 v76" fill="none"/>
<circle cx="42" cy="56" r="7" fill="#3B3355" stroke="none"/><circle cx="78" cy="56" r="7" fill="#3B3355" stroke="none"/><circle cx="40" cy="84" r="6" fill="#3B3355" stroke="none"/><circle cx="80" cy="84" r="6" fill="#3B3355" stroke="none"/>
<path d="M32 50 q4 -10 14 -14" fill="none" stroke="#fff" stroke-width="4" opacity=".7"/>` },

  { id: "spider", en: "Spider", da: "Edderkop", svg: `
<path d="M60 4 v40" fill="none" stroke-width="2.5"/>
<path d="M40 60 q-16 -14 -28 -6 M40 70 q-16 -4 -28 6 M42 78 q-12 8 -22 22 M44 66 q-18 -24 -30 -24 M80 60 q16 -14 28 -6 M80 70 q16 -4 28 6 M78 78 q12 8 22 22 M76 66 q18 -24 30 -24" fill="none" stroke-width="5"/>
<circle cx="60" cy="70" r="24" fill="#A78BFA"/><circle cx="60" cy="46" r="12" fill="#A78BFA"/>
<circle cx="55" cy="46" r="4" fill="#fff" stroke-width="2.5"/><circle cx="65" cy="46" r="4" fill="#fff" stroke-width="2.5"/>
<path d="M50 70 q10 8 20 0" fill="none" stroke="#7C5BD6" stroke-width="4"/>` },

  { id: "bird", en: "Bird", da: "Fugl", svg: `
<path d="M100 44 l14 6 -14 6Z" fill="#FFC857"/>
<path d="M20 70 C20 40 50 26 76 32 C96 36 104 50 100 62 C96 86 66 98 40 92 C30 98 18 102 8 98 C16 92 20 82 20 70Z" fill="#7FC8F8"/>
<path d="M36 64 C50 56 66 62 70 76 C56 84 40 80 36 64Z" fill="#4A90D9"/>
<circle cx="84" cy="48" r="5" fill="#3B3355" stroke="none"/><circle cx="85.5" cy="46.5" r="1.6" fill="#fff" stroke="none"/>
<path d="M50 96 v12 M64 94 v14" fill="none" stroke="#FF7A45" stroke-width="4"/>` },

  { id: "fish", en: "Fish", da: "Fisk", svg: `
<path d="M86 60 l24 -22 v44Z" fill="#FF7A45"/>
<path d="M10 60 C24 32 70 26 92 60 C70 94 24 88 10 60Z" fill="#FFC857"/>
<path d="M50 38 q10 -14 22 -4" fill="#FF7A45"/>
<path d="M44 44 q8 16 0 32 M60 44 q6 16 0 32" fill="none" stroke="#E0A955" stroke-width="4"/>
<circle cx="28" cy="56" r="5" fill="#3B3355" stroke="none"/><circle cx="29.5" cy="54.5" r="1.6" fill="#fff" stroke="none"/>
<circle cx="14" cy="30" r="4" fill="#DDF1FF" stroke-width="2.5"/><circle cx="22" cy="18" r="3" fill="#DDF1FF" stroke-width="2.5"/>` },

  { id: "frog", en: "Frog", da: "Frø", svg: `
<path d="M14 96 q8 -14 20 -10 M106 96 q-8 -14 -20 -10" fill="none" stroke-width="5"/>
<path d="M18 80 C18 56 36 46 60 46 C84 46 102 56 102 80 C102 98 82 104 60 104 C38 104 18 98 18 80Z" fill="#7BD389"/>
<circle cx="38" cy="42" r="15" fill="#7BD389"/><circle cx="82" cy="42" r="15" fill="#7BD389"/>
<circle cx="38" cy="40" r="8" fill="#fff"/><circle cx="82" cy="40" r="8" fill="#fff"/><circle cx="39" cy="41" r="4" fill="#3B3355" stroke="none"/><circle cx="83" cy="41" r="4" fill="#3B3355" stroke="none"/>
<path d="M40 74 q20 14 40 0" fill="none"/>
<ellipse cx="60" cy="92" rx="18" ry="8" fill="#9BE3A6" stroke="none"/>` },

  { id: "snake", en: "Reptile", da: "Krybdyr", svg: `
<path d="M22 100 h52 a16 16 0 0 0 0 -32 h-28 a16 16 0 0 1 0 -32 h20" fill="none" stroke="#3B3355" stroke-width="20"/>
<path d="M22 100 h52 a16 16 0 0 0 0 -32 h-28 a16 16 0 0 1 0 -32 h20" fill="none" stroke="#7BD389" stroke-width="12"/>
<path d="M40 100 h6 M62 100 h6 M86 80 l4 4 M56 68 h6 M34 48 l4 -4" fill="none" stroke="#5BB46C" stroke-width="5"/>
<path d="M66 22 h14 a12 12 0 0 1 0 24 h-14Z" fill="#7BD389"/>
<circle cx="80" cy="30" r="3.5" fill="#3B3355" stroke="none"/>
<path d="M92 36 h10 l4 -4 M102 36 l4 4" fill="none" stroke="#E8556D" stroke-width="3"/>` },

  { id: "turtle", en: "Turtle", da: "Skildpadde", svg: `
<ellipse cx="96" cy="70" rx="12" ry="10" fill="#9BE3A6"/>
<path d="M30 86 v14 h12 v-12 M70 86 v14 h12 v-12" fill="#9BE3A6"/>
<path d="M18 84 C18 50 38 32 60 32 C82 32 100 50 100 84 Z" fill="#5BB46C"/>
<path d="M44 46 l16 -6 16 6 v16 l-16 6 -16 -6Z M28 70 l16 -8 M92 70 l-16 -8 M60 68 v16" fill="none" stroke-width="3"/>
<path d="M12 84 h96" fill="none" stroke-width="5"/>
<circle cx="100" cy="66" r="2.5" fill="#3B3355" stroke="none"/>` },

  { id: "lion", en: "Lion", da: "Løve", svg: `
<path d="M60 8 l10 10 14 -4 4 14 14 4 -4 14 10 10 -10 10 4 14 -14 4 -4 14 -14 -4 -10 10 -10 -10 -14 4 -4 -14 -14 -4 4 -14 -10 -10 10 -10 -4 -14 14 -4 4 -14 14 4Z" fill="#E0A955"/>
<circle cx="60" cy="62" r="30" fill="#FFC857"/>
<circle cx="38" cy="38" r="8" fill="#FFC857"/><circle cx="82" cy="38" r="8" fill="#FFC857"/>
<circle cx="49" cy="56" r="4" fill="#3B3355" stroke="none"/><circle cx="71" cy="56" r="4" fill="#3B3355" stroke="none"/>
<path d="M54 68 h12 l-6 7Z" fill="#8E5E40" stroke-width="3"/>
<path d="M60 75 v4 q-6 6 -12 2 M60 79 q6 6 12 2" fill="none" stroke-width="3"/>
<circle cx="42" cy="70" r="5" fill="#FF9BB0" stroke="none" opacity=".7"/><circle cx="78" cy="70" r="5" fill="#FF9BB0" stroke="none" opacity=".7"/>` },

  { id: "cow", en: "Mammal", da: "Pattedyr", svg: `
<path d="M30 34 q-14 -10 -16 -24 q14 4 22 16 M90 34 q14 -10 16 -24 q-14 4 -22 16" fill="#F4E1C1"/>
<ellipse cx="20" cy="46" rx="12" ry="7" fill="#fff" transform="rotate(-20 20 46)"/><ellipse cx="100" cy="46" rx="12" ry="7" fill="#fff" transform="rotate(20 100 46)"/>
<path d="M28 40 C28 22 92 22 92 40 V70 H28Z" fill="#fff"/>
<path d="M30 36 q10 -12 22 -6 q-2 14 -22 14Z" fill="#3B3355" stroke="none"/>
<rect x="24" y="64" width="72" height="42" rx="21" fill="#FF9BB0"/>
<circle cx="46" cy="84" r="5" fill="#C8604A" stroke="none"/><circle cx="74" cy="84" r="5" fill="#C8604A" stroke="none"/>
<circle cx="46" cy="52" r="4.5" fill="#3B3355" stroke="none"/><circle cx="74" cy="52" r="4.5" fill="#3B3355" stroke="none"/>` },

  { id: "dolphin", en: "Dolphin", da: "Delfin", svg: `
<path d="M8 104 q14 -8 28 0 t28 0 t28 0 t28 0" fill="none" stroke="#7FC8F8" stroke-width="5"/>
<path d="M18 86 C26 46 60 22 96 30 l14 -4 -6 10 C108 44 104 52 96 52 C80 50 66 56 56 70 L64 84 L46 78 C38 84 30 90 18 86Z" fill="#7FC8F8"/>
<path d="M60 30 l-6 -14 18 10" fill="#4A90D9"/>
<path d="M28 82 C40 70 54 62 72 58" fill="none" stroke="#fff" stroke-width="4" opacity=".8"/>
<circle cx="88" cy="40" r="3.5" fill="#3B3355" stroke="none"/>` },

  { id: "bat", en: "Bat", da: "Flagermus", svg: `
<path d="M60 44 C46 30 22 28 8 40 C16 44 20 50 18 58 C26 54 34 56 36 64 C42 58 50 58 54 66 Z" fill="#A78BFA"/>
<path d="M60 44 C74 30 98 28 112 40 C104 44 100 50 102 58 C94 54 86 56 84 64 C78 58 70 58 66 66 Z" fill="#A78BFA"/>
<path d="M48 36 l2 -14 8 10 h4 l8 -10 2 14 v20 a12 12 0 0 1 -24 0Z" fill="#7C5BD6"/>
<circle cx="55" cy="44" r="3.5" fill="#fff" stroke="none"/><circle cx="65" cy="44" r="3.5" fill="#fff" stroke="none"/>
<path d="M56 54 l2 4 2 -4 2 4 2 -4" fill="none" stroke="#fff" stroke-width="2"/>
<circle cx="94" cy="92" r="10" fill="#FFE37A"/>` },

  { id: "egg", en: "Egg", da: "Æg", svg: `
<path d="M60 12 C84 12 98 52 98 72 a38 38 0 0 1 -76 0 C22 52 36 12 60 12Z" fill="#FFF3DC"/>
<path d="M38 58 q2 -18 14 -30" fill="none" stroke="#fff" stroke-width="6"/>
<circle cx="72" cy="80" r="4" fill="#F4C976" stroke="none"/><circle cx="50" cy="90" r="3" fill="#F4C976" stroke="none"/><circle cx="76" cy="52" r="3" fill="#F4C976" stroke="none"/>` },

  { id: "heart", en: "Heart", da: "Hjerte", svg: `
<path d="M60 100 C20 74 8 50 22 32 C34 18 52 22 60 38 C68 22 86 18 98 32 C112 50 100 74 60 100Z" fill="#FF6B81"/>
<path d="M30 40 q4 -8 12 -8" fill="none" stroke="#fff" stroke-width="5"/>
<path d="M20 62 h22 l6 -12 8 24 8 -18 5 6 h31" fill="none" stroke="#fff" stroke-width="5"/>` },

  { id: "brain", en: "Brain", da: "Hjerne", svg: `
<path d="M58 22 C48 12 30 16 28 30 C14 32 10 50 18 58 C10 68 16 86 30 86 C34 100 52 102 58 92 Z" fill="#FF9BB0"/>
<path d="M62 22 C72 12 90 16 92 30 C106 32 110 50 102 58 C110 68 104 86 90 86 C86 100 68 102 62 92 Z" fill="#FF9BB0"/>
<path d="M30 46 q10 -4 14 6 q-6 8 2 14 M24 66 q10 2 16 -4 M44 80 q2 -8 10 -8 M38 32 q8 2 10 10" fill="none" stroke="#E8556D" stroke-width="3.5"/>
<path d="M90 46 q-10 -4 -14 6 q6 8 -2 14 M96 66 q-10 2 -16 -4 M76 80 q-2 -8 -10 -8 M82 32 q-8 2 -10 10" fill="none" stroke="#E8556D" stroke-width="3.5"/>
` },

  { id: "bone", en: "Skeleton", da: "Skelet", svg: `
<g transform="rotate(-35 60 60)"><path d="M30 50 a12 12 0 1 1 6 -18 a12 12 0 1 1 10 18 h28 a12 12 0 1 1 10 -18 a12 12 0 1 1 6 18 v20 a12 12 0 1 1 -6 18 a12 12 0 1 1 -10 -18 h-28 a12 12 0 1 1 -10 18 a12 12 0 1 1 -6 -18Z" fill="#FFF3DC"/>
<path d="M44 56 h32" fill="none" stroke="#fff" stroke-width="5"/></g>` },

  { id: "lungs", en: "Lungs", da: "Lunger", svg: `
<path d="M60 10 v40 M60 50 q-6 8 -14 10 M60 50 q6 8 14 10" fill="none" stroke-width="8"/><path d="M60 10 v40" fill="none" stroke="#FFF3DC" stroke-width="3"/>
<path d="M50 36 C30 30 14 52 14 80 C14 100 26 106 38 104 C48 102 52 94 52 84 V44 C52 40 52 37 50 36Z" fill="#FF9BB0"/>
<path d="M70 36 C90 30 106 52 106 80 C106 100 94 106 82 104 C72 102 68 94 68 84 V44 C68 40 68 37 70 36Z" fill="#FF9BB0"/>
<path d="M28 60 q2 -10 10 -14 M38 74 l-10 8 M82 74 l10 8" fill="none" stroke="#E8556D" stroke-width="3.5"/>` },

  { id: "tooth", en: "Tooth", da: "Tand", svg: `
<path d="M60 26 C70 14 98 12 98 40 C98 58 90 66 88 84 C86 100 82 108 76 108 C68 108 68 84 60 84 C52 84 52 108 44 108 C38 108 34 100 32 84 C30 66 22 58 22 40 C22 12 50 14 60 26Z" fill="#fff"/>
<path d="M34 34 q4 -10 14 -10" fill="none" stroke="#B7E0FB" stroke-width="5"/>
<path d="M100 16 l3 6 6 1 -5 4 1 6 -5 -3 -5 3 1 -6 -5 -4 6 -1z" fill="#FFE37A" stroke-width="2.5"/>` },

  { id: "eye", en: "Eye", da: "Øje", svg: `
<path d="M8 60 C26 30 94 30 112 60 C94 90 26 90 8 60Z" fill="#fff"/>
<circle cx="60" cy="60" r="22" fill="#7FC8F8"/><circle cx="60" cy="60" r="11" fill="#3B3355" stroke="none"/>
<circle cx="66" cy="53" r="5" fill="#fff" stroke="none"/>
<path d="M26 28 l-6 -8 M44 20 l-2 -9 M60 18 v-9 M76 20 l2 -9 M94 28 l6 -8" fill="none" stroke-width="4"/>` },

  { id: "apple", en: "Apple", da: "Æble", svg: `
<path d="M60 34 C40 22 14 30 16 62 C18 92 40 110 60 100 C80 110 102 92 104 62 C106 30 80 22 60 34Z" fill="#E8556D"/>
<path d="M60 34 q2 -14 10 -22" fill="none" stroke="#8E5E40" stroke-width="5"/>
<path d="M66 22 q16 -14 30 -6 q-12 16 -30 6Z" fill="#7BD389"/>
<path d="M30 52 q2 -10 12 -14" fill="none" stroke="#fff" stroke-width="5"/>` },

  { id: "carrot", en: "Vegetables", da: "Grøntsager", svg: `
<path d="M60 30 q-14 -20 -6 -26 q8 8 6 26 q4 -18 14 -24 q4 10 -14 24 q16 -10 26 -6 q-6 10 -26 6Z" fill="#7BD389" stroke-width="3"/>
<path d="M40 34 C56 26 82 30 76 50 L34 108 C28 112 22 106 26 100 Z" fill="#FF7A45"/>
<path d="M48 54 l10 4 M42 72 l10 4 M56 44 l8 2 M36 88 l8 4" fill="none" stroke-width="3"/>` },

  { id: "mountain", en: "Mountain", da: "Bjerg", svg: `
<path d="M4 104 L44 34 L64 66 L80 46 L116 104Z" fill="#B5B9D4"/>
<path d="M44 34 L34 52 l8 -4 6 6 6 -6 2 4Z M80 46 l-8 12 6 -2 4 4 6 -4Z" fill="#fff" stroke-width="3"/>
<path d="M56 104 L80 62" fill="none" stroke="#9AA0C2" stroke-width="4"/>
<circle cx="96" cy="22" r="9" fill="#FFC857"/>` },

  { id: "rock", en: "Rocks", da: "Sten", svg: `<g transform="translate(-12 -22) scale(1.2)">
<path d="M14 100 L22 66 L46 52 L70 60 L80 80 L72 100Z" fill="#B5B9D4"/>
<path d="M62 100 L68 74 L88 62 L108 74 L110 100Z" fill="#C9CCE0"/>
<path d="M28 70 l14 -8 M36 84 l10 6 M80 76 l10 -4" fill="none" stroke-width="3"/>
<circle cx="46" cy="74" r="4" fill="#E07A5F" stroke-width="2.5"/><circle cx="92" cy="86" r="3.5" fill="#FFC857" stroke-width="2.5"/>
<path d="M8 104 h104" fill="none"/></g>` },

  { id: "crystal", en: "Crystal", da: "Krystal", svg: `
<path d="M36 22 h48 l20 26 -44 58 -44 -58Z" fill="#B7E0FB"/>
<path d="M16 48 h88 M36 22 l12 26 12 -26 12 26 12 -26 M48 48 l12 58 12 -58" fill="none" stroke-width="3.5"/>
<path d="M48 48 l12 58 12 -58Z" fill="#DDF1FF" stroke="none"/>
<path d="M48 48 l12 58 12 -58" fill="none" stroke-width="3.5"/>
<path d="M100 10 l2 5 5 1 -4 3 1 5 -4 -3 -4 3 1 -5 -4 -3 5 -1z M20 88 l2 4 4 1 -3 3 1 4 -4 -2 -4 2 1 -4 -3 -3 4 -1z" fill="#fff" stroke-width="2"/>` },

  { id: "gold", en: "Gold", da: "Guld", svg: `
<path d="M14 98 l8 -20 h32 l8 20Z M58 98 l8 -20 h32 l8 20Z M36 76 l8 -20 h32 l8 20Z" fill="#FFC857"/>
<path d="M24 82 h28 M68 82 h28 M46 60 h28" fill="none" stroke="#fff" stroke-width="4"/>
<path d="M88 22 l3 8 8 2 -6 5 2 8 -7 -4 -7 4 2 -8 -6 -5 8 -2z" fill="#FFE37A" stroke-width="2.5"/>` },

  { id: "volcano", en: "Volcano", da: "Vulkan", svg: `
<path d="M48 22c-6-8 4-14 10-9 4-7 16-4 14 5 8 0 9 10 2 12" fill="#E5E1EE"/>
<path d="M14 104 L46 46 L74 46 L106 104Z" fill="#B07A57"/>
<path d="M46 46 L54 58 L60 50 L66 60 L74 46Z" fill="#FF7A45"/>
<path d="M60 60 L56 76 L63 88" fill="none" stroke="#FF7A45"/>
<circle cx="45" cy="80" r="3" stroke="none" fill="#8E5E40"/><circle cx="80" cy="90" r="3" stroke="none" fill="#8E5E40"/>` },

  { id: "ocean", en: "Ocean", da: "Hav", svg: `
<path d="M6 70 C20 40 50 34 64 52 C54 50 50 60 58 66 C70 74 86 62 82 48 C98 54 110 64 114 70 V110 H6Z" fill="#7FC8F8"/>
<path d="M6 90 q14 -8 27 0 t27 0 t27 0 t27 0" fill="none" stroke="#fff" stroke-width="4"/>
<path d="M30 58 q8 -10 18 -8" fill="none" stroke="#fff" stroke-width="4"/>
<circle cx="96" cy="26" r="10" fill="#FFC857"/>` },

  { id: "rainbow", en: "Light & colours", da: "Lys og farver", svg: `
<g fill="none" stroke-linecap="butt"><path d="M14 92 a46 46 0 0 1 92 0" stroke="#3B3355" stroke-width="34"/><path d="M14 92 a46 46 0 0 1 92 0" stroke="#E8556D" stroke-width="7"/><path d="M21 92 a39 39 0 0 1 78 0" stroke="#FFC857" stroke-width="7"/><path d="M28 92 a32 32 0 0 1 64 0" stroke="#7BD389" stroke-width="7"/><path d="M35 92 a25 25 0 0 1 50 0" stroke="#7FC8F8" stroke-width="7"/></g>
<path d="M4 98 a10 10 0 0 1 10 -16 a12 12 0 0 1 22 6 a8 8 0 0 1 -2 14 h-26Z M84 98 a10 10 0 0 1 10 -16 a12 12 0 0 1 22 6 a8 8 0 0 1 -2 14 h-26Z" fill="#fff"/>` },

  { id: "gear", en: "Machine", da: "Maskine", svg: `
<path d="M54 10 h12 l2 12 a38 38 0 0 1 10 4 l10 -7 8 8 -7 10 a38 38 0 0 1 4 10 l12 2 v12 l-12 2 a38 38 0 0 1 -4 10 l7 10 -8 8 -10 -7 a38 38 0 0 1 -10 4 l-2 12 h-12 l-2 -12 a38 38 0 0 1 -10 -4 l-10 7 -8 -8 7 -10 a38 38 0 0 1 -4 -10 l-12 -2 v-12 l12 -2 a38 38 0 0 1 4 -10 l-7 -10 8 -8 10 7 a38 38 0 0 1 10 -4Z" fill="#B5B9D4"/>
<circle cx="60" cy="60" r="16" fill="#FFC857"/>
<path d="M36 46 q6 -10 16 -12" fill="none" stroke="#fff" stroke-width="4"/>` },

  { id: "windturbine", en: "Green energy", da: "Grøn energi", svg: `
<path d="M54 108 l3 -60 h6 l3 60Z" fill="#fff"/>
<path d="M60 44 l-6 -34 q6 -4 10 2Z" fill="#fff"/><path d="M60 44 l32 14 q0 8 -8 8Z" fill="#fff"/><path d="M60 44 l-26 24 q-6 -4 -2 -10Z" fill="#fff"/>
<circle cx="60" cy="44" r="6" fill="#7BD389"/>
<path d="M30 108 q30 -14 60 0" fill="#7BD389"/>
<path d="M90 24 q8 0 10 -6 M94 32 q8 0 12 -4" fill="none" stroke="#7FC8F8" stroke-width="4"/>` },

  { id: "recycle", en: "Environment", da: "Miljø", svg: `
<circle cx="60" cy="70" r="38" fill="#7FC8F8"/>
<path d="M28 58 q10 -10 22 -6 q6 8 -2 14 q-4 10 -14 8 q-8 -4 -6 -16Z M70 84 q10 -10 22 -4 q0 12 -12 18 q-10 0 -10 -14Z" fill="#7BD389"/>
<path d="M60 32 v-12" fill="none" stroke-width="5"/>
<path d="M60 22 q-18 -2 -22 -16 q18 -2 22 16Z" fill="#7BD389"/><path d="M60 20 q16 -4 22 -16 q-18 0 -22 16Z" fill="#9BE3A6"/>
<path d="M36 82 q6 12 18 16" fill="none" stroke="#fff" stroke-width="4" opacity=".7"/>` },
];
